"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _PresetMenu = _interopRequireDefault(require("./PresetMenu"));

var _Button = _interopRequireDefault(require("./Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "ButtonPanel__Wrapper",
  componentId: "sc-dc231x-0"
})(["display:flex;align-items:center;padding:12px 22px 24px;width:618px;"]);

var ButtonPanel = function ButtonPanel(_ref) {
  var onUpdate = _ref.onUpdate,
      onCancel = _ref.onCancel,
      onPresetClick = _ref.onPresetClick,
      checkPresetActive = _ref.checkPresetActive;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: "DateRangePicker__ButtonPanel"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: onUpdate
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "UpdateButton"
  }, "Update")), /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: onCancel,
    btnLink: true,
    style: {
      marginLeft: 36
    }
  }, "Cancel"), /*#__PURE__*/_react.default.createElement("div", {
    className: "DateRangePicker__Header"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Select Date Range")), /*#__PURE__*/_react.default.createElement(_PresetMenu.default, {
    onPresetClick: onPresetClick,
    checkPresetActive: checkPresetActive
  }));
};

ButtonPanel.propTypes = {
  onUpdate: _propTypes.default.func.isRequired,
  onCancel: _propTypes.default.func.isRequired,
  onPresetClick: _propTypes.default.func.isRequired,
  checkPresetActive: _propTypes.default.func.isRequired
};
var _default = ButtonPanel;
exports.default = _default;